/**
 * @generated SignedSource<<519c29152da10b702f93438eb0cfc2c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDetailReturnPolicy_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"useShippingAndReturns_user">;
  readonly " $fragmentType": "PdpSharedDetailReturnPolicy_user";
};
export type PdpSharedDetailReturnPolicy_user$key = {
  readonly " $data"?: PdpSharedDetailReturnPolicy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDetailReturnPolicy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDetailReturnPolicy_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShippingAndReturns_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6fa61d10d560623dcad2746f09686b3b";

export default node;
